import { LinearProgress } from '@material-ui/core'
import { FunctionComponent } from 'react'
import { AccessibleOverlayTrigger } from 'studiokit-scaffolding-js/lib/components/AccessibleOverlayTrigger'
import { ClientConfig } from '../../types/ClientConfig'
import { TokenUsage } from '../../types/TokenUsage'
import { IconGauge } from '../Shared/Icons/IconGauge'
import { formatResumesAt, getUsedPercent } from './UsageMeter.support'

import './UsageMeter.css'

interface UsageMeterProps {
	usage: TokenUsage
	clientConfig: ClientConfig
	/** Opens the help modal, where the limits are explained in full. */
	onLearnMore: () => void
}

export const UsageMeter: FunctionComponent<UsageMeterProps> = ({ usage, clientConfig, onLearnMore }) => {
	const usedPercent = getUsedPercent(usage.used, clientConfig.maxUserTokenCount)
	const remainingPercent = 100 - usedPercent
	// the window slides, so there is only a time to wait for once the user is over the limit
	const resumesAtLabel = usage.hasExceededLimit ? formatResumesAt(usage.resumesAt) : undefined

	return (
		<AccessibleOverlayTrigger
			placement="bottom"
			popoverClassName="bg-color-blue-grey fill-blue-grey usage-meter-popover"
			trigger={['hover', 'focus']}
			overlay={
				<div>
					<h2 className="f5 mt2 mb2 color-white bg-color-blue-grey">Usage limits</h2>
					<p className="mb2 color-white bg-color-blue-grey">
						This bar shows how much of your usage limit you have used. At 100%, new uploads pause until it
						resets.
					</p>
				</div>
			}>
			<button
				type="button"
				onClick={onLearnMore}
				id="UsageMeter"
				className={`${usage.hasExceededLimit ? 'limit-reached ' : ''}usage-meter flex flex-column tl pa0 mr2 pointer btn-outline br3 color-dark-grey w-60 mb0`}>
				<span className="flex items-center mb2 justify-between">
					<div>
						<IconGauge className="usage-meter-icon mr1 f5" />
						<span className="usage-meter-label mr2 f7">Hourly usage</span>
					</div>
					<span className="usage-meter-percent fw6 f7">{usedPercent}%</span>
				</span>
				{/* the percentages either side say everything the bar does */}
				<LinearProgress
					variant="determinate"
					value={usedPercent}
					className="usage-meter-track br4"
					aria-hidden
				/>
				<span
					className={`usage-meter-remaining f8 mt1 fw4 ${usage.hasExceededLimit ? 'color-darker-orange fw6' : ''}`}>
					{remainingPercent}% left
					{resumesAtLabel && ` · resets at ${resumesAtLabel}`}
				</span>
			</button>
		</AccessibleOverlayTrigger>
	)
}
